/**
 * Props for HTML5 video elements to hide the browser download control where supported.
 */
export const restrictedVideoProps = {
  controlsList: 'nodownload noplaybackrate noremoteplayback',
  disablePictureInPicture: true,
  onContextMenu: (e) => e.preventDefault(),
};
